export default __webpack_public_path__ + "static/media/screenshot-2.67077fc6.png";